/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginStatusDto } from '../../models/login-status-dto';

export interface AuthControllerCreateAccessTokenFromRefreshToken$Params {
}

export function authControllerCreateAccessTokenFromRefreshToken(http: HttpClient, rootUrl: string, params?: AuthControllerCreateAccessTokenFromRefreshToken$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginStatusDto>> {
  const rb = new RequestBuilder(rootUrl, authControllerCreateAccessTokenFromRefreshToken.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoginStatusDto>;
    })
  );
}

authControllerCreateAccessTokenFromRefreshToken.PATH = '/api/auth/refresh';
